module.exports = __webpack_public_path__ + "static/media/financas.0a6c9292.svg";